/*
 * @Author: cc
 * @LastEditTime: 2022-01-26 16:41:51
 */
import { useLocation } from "react-router-dom";
import { post } from "src/component/fetch"
import store from "src/reducers/index";
import { isInApp, webCallApp } from "src/utils/web-call-app";
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
// 获取url参数
export function getQueryVariable(variable: string) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}
export function IsPc() {
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileAgents = [
    "android",
    "iphone",
    "symbianos",
    "windows phone",
    "ipad",
    "ipod",
    "harmonyos",
    "openharmony" // 添加对 OpenHarmony 的检测
  ];

  return !mobileAgents.some(agent => userAgent.includes(agent));
}
// const getValueFromEvent = (e: any) => {
//   console.log(e.target.value);
//   return e.target.value.replace(/(^\s*)|(\s*$)/g, "");
// };
// function StartComponent(props: any) {
//   const { required } = props;
//   return (
//     <span
//       style={{ color: "red", width: "10px" }}
//       className={required ? "" : "hideStart"}
//     >
//       *
//     </span>
//   );
// }
export const IsPC = IsPc();

function getViodePopNumber() {
  const data = store.getState();
  const { randomPopUpNum } = data.videoStatus;
  return randomPopUpNum;
}
class videoPause {
  count: number;
  constructor() {
    this.count = getViodePopNumber();
  }
  start(video: any, position: any, time: any, videoStatus: any) {
    const { onHookTipInfo, videoUniqueCode, projectId, topicId, courseId, sectionId } = videoStatus;
    if (window.pauseTimer === null && this.count > 0) {
      // 随机数
      let restTime = time - parseInt(position);
      let randonNum = Math.floor(Math.random() * (restTime - 0) + 0);
      window.pauseTimer = setInterval(() => {
        console.log("多少秒之后暂停弹窗", randonNum);
        console.log("剩余弹出次数", this.count);
        if (randonNum <= 0) {
          // video.pause();
          // this.pause(); 
          setTimeout(() => {
            let popupUniqueCode = new Date().getTime() + ''
            post('/shop/front/addUserWatchPopupLog', { projectId, topicId, courseId, sectionId, videoUniqueCode, popupUniqueCode, popupType: 1 }, false)
            alert(onHookTipInfo);
            this.count--;
            post('/shop/front/addUserWatchPopupLog', { projectId, topicId, courseId, sectionId, videoUniqueCode, popupUniqueCode, popupType: 2 }, false)
          }, 800);
        } else {
          randonNum--;
        }
      }, 1000);
    }
  }
  pause() {
    console.log("-----清空计时器-----");
    clearInterval(window.pauseTimer);
    window.pauseTimer = null;
  }
  reset() {
    // 设置弹出次数
    this.count = getViodePopNumber();
  }
}
export let ranDomNum = new videoPause();
export const watch = () => {
  const data = store.getState();
  const {
    videoStatus,
  } = data as any;
  const {
    courseId,
    sectionId,
    columnId,
    subjectId,
  } = videoStatus;
  if (!window.ccPlayerStatus) return;
  const videoDuration = parseInt(window.ccPlayerStatus.getDuration());
  const watchAt = parseInt(window.ccPlayerStatus.getPosition());
  if (!window.ccPlayerStatus.getDuration()) return;
  if (window.ccPlayerStatus.getPosition() === 0) return;
  // //获取总时长
  // let time = window.ccPlayerStatus.getDuration();
  // let video = window.ccPlayerStatus;
  // //获取视频进度watch
  // let position = window.ccPlayerStatus.getPosition();
  // // 调用随机弹窗的方法
  // if (preventOnHookFlag === 2) {
  //   ranDomNum.start(video, position, time, videoStatus);
  // }
  let url = "";
  let param: any = {
    courseId,
    sectionId,
    columnId,
    subjectId,
    // projectId: projectId ? projectId : "",
    videoDuration,
    watchAt,
    watchChannel: IsPC ? 1 : isInApp() ? 2 : 3
  };
  if (watchAt === 0) {
    return
  }
  url = "/shop/front/ge/column/saveWatchRecord"
  post(url, param, false);
};

export function preventOpenMoreVideoFn(watchStatus: "1" | "0") {
  const data = store.getState();
  const { preventConcurrentPlayFlag } = data.videoStatus;
  // 0关闭 1开启
  if (preventConcurrentPlayFlag === 0) {
    return;
  }
  if (!window.ccPlayerStatus) return;
  let hashVal = sessionStorage.getItem("hashVal");
  if (!hashVal) {
    // 本地存储一个HashVal
    var timeStamp = new Date().valueOf().toString();
    sessionStorage.setItem("hashVal", timeStamp);
  }
  const { projectId } = data.videoStatus;
  post(
    `/shop/aboutWatchVideoController/watchingVideo`,
    {
      hashVal: sessionStorage.getItem("hashVal"),
      watchStatus,
      projectId,
    },
    false
  ).catch((result: any) => {
    // 必须是观看状态下
    if (result.code !== 0) {
      ranDomNum.pause();
      window.ccPlayerStatus.pause();
    }
  });
}
export function wx_share(title: string, desc: string, link: string, imgUrl: string) {
  window.wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
    window.wx.updateAppMessageShareData({
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl, // 分享图标
      success: function () {
        console.log('--------------------设置成功---------------------')
        // 设置成功
      },
      error: function () {
        console.log('------------------------设置失败--------------------------')
      }
    })
  });
}